import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {cloneDeep, startCase} from 'lodash';

// PrimeReact components
import {TabView, TabPanel} from 'primereact/tabview';
import {Dropdown} from 'primereact/dropdown';
import {Checkbox} from 'primereact/checkbox';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';
import {RadioButton} from 'primereact/radiobutton';
import {Button as PrimeButton} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';

// Components
import LaunchIdTreeTable from './launchIdTreeView';

// Criteria custom UI components
import CriteriaForm from './criteria-form';

// Boost custom UI components
import BoostListTable from '../components-core/boost-list';

// SortOption custom UI components
import SortOptionList from '../components-core/sort-option-list';

// Redux Actions
import * as shelfActions from '../actions/shelf-actions';
import {push} from '../actions/router-actions';
import {getGlobalShelvesTree} from '../actions/services-data-actions';

// Radar UI components
import Form from '../components-core/form';
import Button from '../components-core/button';

// Catalog constants
import * as catalogConstants from '../catalog/catalog-constants';

// Styles
import './shelf-form.scss';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Icon from '../components-core/icon';

const styles = {
    buttonBlock: {marginBottom: 16, float: 'right'},
    criteriaButton: {marginTop: 30, width: 120},
    checkboxes: {marginTop: 16},
    divBlock: {marginBottom: 16},
    shelfType: {marginBottom: 16, marginRight: 16},
    tabs: {width: 800, padding: 16},
    generateLaunchId: {marginLeft: 32, marginTop: 20},
    generateLaunchIdA: {marginLeft: 0},
    generateLaunchIdL: {marginLeft: 32},
    generateLaunchIdC: {marginLeft: 32},
    generateLaunchIdMethod: {marginTop: 16},
    generatedLaunchIdField: {
        marginLeft: 32,
        backgroundColor: '#07619c',
        color: 'white',
        padding: '5px 10px 5px 12px',
        borderRadius: 20,
    },
    generatedLaunchIdField2: {
        marginLeft: 5,
        backgroundColor: '#007ad9',
        color: 'white',
        padding: '5px 10px 5px 12px',
        borderRadius: 20,
    },
    generatedLaunchIdDiv: {marginTop: 10, marginBottom: 10, marginLeft: -30, fontWeight: 600},
    checkbox: {marginTop: 4},
    showLaunchList: {marginLeft: 32, height: 32, marginTop: 10},
    label: {marginLeft: 8},
    renderShelfDiv: {marginLeft: 32, marginTop: 20},
    renderShelfLabel: {marginLeft: 8},
    limit: {width: 100},
    description: {width: 835},
    groupedDiv: {marginLeft: 32, marginTop: 20},
    groupedLabel: {marginLeft: 8},
    shelfName: {width: 'auto', height: 39, minWidth: 320},
    typeDropdown: {width: 200},
    errorMessage: {
        color: 'white',
        fontWeight: 800,
        fontSize: '1rem',
        paddingRight: 16,
        paddingLeft: 16,
        borderRadius: 20,
        backgroundColor: 'red',
    },
    lid: {marginBottom: 16},
    lid_warning: {color: '#07619c', fontWeight: 600, display: 'flex'},
    lid_error: {color: 'red', fontWeight: 600},
    lid_button: {marginTop: 8},
    loadingBlock: {color: '#007ad9', minHeight: 50, maxHeight: 50},
    loaderSpinner: {position: 'absolute', marginTop: 30, marginLeft: 0},
    loadingDiv: {color: '#007ad9', fontSize: '1.5rem'},
    loadingIcon: {marginTop: 5, marginBottom: 5},
    launchIdInfo: {marginBottom: 10, color: '#191919', backgroundColor: '#eaf4fb', padding: 5},
    infoIcon: {fontSize: '2rem', color: 'orange'},
    infoText: {marginTop: 5},
};

class ShelfForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            boosts: [],
            criteria: [],
            criteriaSelection: catalogConstants.CriterionList.Actor.criterionName,
            firstRender: true,
            generateLaunchId: false,
            generateLaunchIdMethod: '',
            showLaunchIdList: false,
            showCustomLaunchId: false,
            launchIdFromListGenerated: null,
            launchIdErrorMessage: false,
            launchId: null,
            customLaunchId: '',
            customLaunchIdValueIsVerified: true,
            loading: false,
            launchIdObject: {},
            shelfAreSeriesFoldersGrouped: false,
            shelfDescription: '',
            shelfId: null,
            shelfIsAlpha: false,
            shelfName: '',
            shelfReturnLimit: '20',
            shelfType: 'ASSET',
            showLaunchIdConfirmation: false,
            sortOptions: [],
            subShelves: [],
            errorMessage: null,
        };
    }

    componentDidMount() {
        const {getGlobalShelvesTree} = this.props;
        getGlobalShelvesTree();
    }

    UNSAFE_componentWillReceiveProps = nextProps => {
        const {firstRender} = this.state;
        const {formName} = this.props;

        if (nextProps.searchValues && nextProps.searchValues.ShelfDTO && firstRender) {
            const criteriaArr = cloneDeep(nextProps.searchValues.ShelfDTO.criteria);
            const criteriaProp = this.prepareCriteriaForEditing(criteriaArr);

            if (formName === 'addShelf') {
                this.setState({
                    boosts: cloneDeep(nextProps.searchValues.ShelfDTO.boosts),
                    criteria: criteriaProp,
                    firstRender: false,
                    sortOptions: cloneDeep(nextProps.searchValues.ShelfDTO.sortOptions),
                    subShelves: [],
                });
            } else {
                this.setState({
                    boosts: cloneDeep(nextProps.searchValues.ShelfDTO.boosts),
                    criteria: criteriaProp,
                    firstRender: false,
                    launchId: cloneDeep(nextProps.searchValues.ShelfDTO.launchId) || null,
                    shelfId: cloneDeep(nextProps.searchValues.ShelfDTO.id),
                    shelfName: cloneDeep(nextProps.searchValues.ShelfDTO.name),
                    shelfDescription: cloneDeep(nextProps.searchValues.ShelfDTO.description),
                    shelfReturnLimit: cloneDeep(nextProps.searchValues.ShelfDTO.returnLimit),
                    shelfIsAlpha: cloneDeep(nextProps.searchValues.ShelfDTO.alpha),
                    shelfAreSeriesFoldersGrouped: cloneDeep(nextProps.searchValues.ShelfDTO.seriesFoldersGrouped),
                    shelfType: cloneDeep(nextProps.searchValues.ShelfDTO.type),
                    sortOptions: cloneDeep(nextProps.searchValues.ShelfDTO.sortOptions),
                    subShelves: cloneDeep(nextProps.searchValues.ShelfDTO.subShelves),
                });
            }
        }
    };

    UNSAFE_componentWillUpdate = nextProps => {
        const {fetching, redirectLocation, push} = this.props;
        const {error} = this.state;

        if (nextProps.error && error !== nextProps.error) {
            this.setState({error: nextProps.error});
        } else if (fetching && !nextProps.fetching) {
            this.setState({}, () => {
                push({redirectLocation});
                window.location.href = redirectLocation;
            });
        }
    };

    getSubmitProps() {
        const {
            customLaunchIdValueIsVerified,
            generateLaunchIdMethod,
            launchIdFromListGenerated,
            generateLaunchId,
            errorMessage,
        } = this.state;
        return {
            type: 'submit',
            disabled:
                !customLaunchIdValueIsVerified ||
                (generateLaunchId && generateLaunchIdMethod === '') ||
                (generateLaunchIdMethod === 'list' && launchIdFromListGenerated == null) ||
                errorMessage != null,
            className: 'shelf-form--submit',
            onClick: this.handleSubmit,
            label: 'Update Shelf',
        };
    }

    getClass() {
        const {className} = this.props;

        return classnames('shelf-form', className);
    }

    getFieldProps(fieldName, type) {
        return {
            className: type === 'checkbox' ? 'shelf-form--checkbox' : 'shelf-form--input',
            label: startCase(fieldName),
            name: fieldName,
            type,
        };
    }

    getCancelButtonProps() {
        return {
            className: 'shelf-form--cancel',
            onClick: this.handleCancelClick,
        };
    }

    getBoostProps() {
        const {boosts} = this.state;

        return {
            boosts,
        };
    }

    getSortOptionProps() {
        const {sortOptions, shelfType} = this.state;

        return {
            sortOptions,
            shelfType,
        };
    }

    prepareCriteriaForEditing = criteria => {
        const criteriaArr = cloneDeep(criteria);
        for (let i = 0; i < criteriaArr.length; i++) {
            if (criteriaArr[i].class === 'Keyword' && criteriaArr[i].fields === 2) {
                criteriaArr[i].class = 'Actor';
            } else if (criteriaArr[i].class === 'SubTheme') {
                criteriaArr[i].genres = this.parseSubTheme(criteria[i].genres);
            } else if (criteriaArr[i].class === 'Resolution') {
                criteriaArr[i].resolution = this.parseResolution(criteria[i].resolution);
            } else if (criteriaArr[i].class === 'Keyword' && criteriaArr[i].fields === 3) {
                criteriaArr[i].class = 'Title';
            }
        }

        return criteriaArr;
    };

    parseResolution = resolution => {
        const defaultResolutionSet = new Set();
        const resolutionSet = new Set();

        if (resolution) {
            for (const currentResolution of catalogConstants.ResolutionList) {
                const resolutionObj = {
                    resId: currentResolution.searchValue,
                    selected: false,
                };

                defaultResolutionSet.add(resolutionObj);
            }

            for (const currentResolution of defaultResolutionSet) {
                const result = currentResolution.resId & resolution;

                const resolutionObj = {
                    resId: currentResolution.resId,
                    selected: result === currentResolution.resId,
                };

                resolutionSet.add(resolutionObj);
            }
        }

        return Array.from(resolutionSet);
    };

    parseSubTheme = genreArr => {
        const subThemeSet = new Set();
        for (const currentGenre of genreArr) {
            if (currentGenre.category === 'MOVIE') {
                for (const movieSubTheme of catalogConstants.MovieSubThemeList) {
                    const result = movieSubTheme.value & currentGenre.genreValue;

                    if (result === movieSubTheme.value) {
                        const genreForSubThemeUI = {
                            category: currentGenre.category,
                            genreValue: movieSubTheme.value,
                            genreName: movieSubTheme.label,
                        };

                        subThemeSet.add(genreForSubThemeUI);
                    }
                }
            } else if (currentGenre.category === 'TVENT') {
                for (const tvEntSubTheme of catalogConstants.TVSubThemeList) {
                    const result = tvEntSubTheme.value & currentGenre.genreValue;

                    if (result === tvEntSubTheme.value) {
                        const genreForSubThemeUI = {
                            category: currentGenre.category,
                            genreValue: tvEntSubTheme.value,
                            genreName: tvEntSubTheme.label,
                        };

                        subThemeSet.add(genreForSubThemeUI);
                    }
                }
            } else if (currentGenre.category === 'ADULT') {
                for (const adultSubTheme of catalogConstants.AdultSubThemeList) {
                    const result = adultSubTheme.value & currentGenre.genreValue;

                    if (result === adultSubTheme.value) {
                        const genreForSubThemeUI = {
                            category: currentGenre.category,
                            genreValue: adultSubTheme.value,
                            genreName: adultSubTheme.label,
                        };

                        subThemeSet.add(genreForSubThemeUI);
                    }
                }
            }
        }
        return Array.from(subThemeSet);
    };

    handleUpdateNetworkTags = (tagArray, criteriaId) => {
        this.setState(prevState => {
            const criteriaArr = cloneDeep(prevState.criteria);
            const res = criteriaId.substring(11);
            const idx = Number(res);
            criteriaArr[idx].tags = tagArray;
            return {criteria: criteriaArr};
        });
    };

    handleSubmit = event => {
        this.setState({loading: true});
        const {formName, updateShelf, parentShelfId} = this.props;
        const {
            launchIdFromListGenerated,
            generateLaunchIdMethod,
            customLaunchId,
            customLaunchIdValueIsVerified,
            launchId,
            shelfId,
            shelfName,
            shelfType,
            shelfDescription,
            shelfIsAlpha,
            shelfAreSeriesFoldersGrouped,
            sortOptions,
            boosts,
            shelfReturnLimit,
            subShelves,
        } = this.state;
        if (!shelfName.length) {
            this.setState({errorMessage: '* Shelf Name is required', loading: false});
        } else {
            event.preventDefault();
            // Wrapper work
            const conditions = this.prepareCriteriaForSubmit();
            let launchIdNew;
            let launchIdFromListGeneratedAdditional;
            if (generateLaunchIdMethod === 'auto') {
                launchIdNew = null;
            } else if (generateLaunchIdMethod === 'list' && launchIdFromListGenerated != null) {
                launchIdNew = launchIdFromListGenerated;
            } else if (generateLaunchIdMethod === 'custom' && customLaunchIdValueIsVerified) {
                launchIdNew = customLaunchId.toString().length === 0 ? null : customLaunchId;
                if (launchIdNew !== null) {
                    launchIdFromListGeneratedAdditional = launchIdNew;
                }
            } else {
                launchIdNew = launchId;
            }

            const wrapper = {
                ShelfDTO: {
                    id: shelfId,
                    launchId: launchIdNew != null ? parseInt(launchIdNew) : null,
                    name: shelfName,
                    description: shelfDescription,
                    generateNewLaunchId: generateLaunchIdMethod === 'auto',
                    subShelves,
                    type: shelfType,
                    returnLimit: shelfReturnLimit,
                    criteria: conditions,
                    sortOptions,
                    boosts,
                    alpha: shelfIsAlpha,
                    seriesFoldersGrouped: shelfAreSeriesFoldersGrouped,
                },
            };
            fetch(`/catalog/shelf/${parentShelfId}`)
                .then(responseText => responseText.json())
                .then(response => {
                    if (launchIdFromListGenerated != null || launchIdFromListGeneratedAdditional != null) {
                        const launchIdNew = launchIdFromListGenerated || launchIdFromListGeneratedAdditional;
                        response.ShelfDTO.subShelves.forEach(r => {
                            const {id, launchId} = r.ShelfDTO;
                            if (launchId && launchId.toString() === launchIdNew.toString() && id !== shelfId) {
                                r.ShelfDTO.launchId = null;
                            }
                        });
                    }
                    if (formName === 'addShelf') {
                        if (shelfId != null) {
                            const shelfIdx = response.ShelfDTO.subShelves.findIndex(
                                element => element.ShelfDTO.id === shelfId
                            );
                            if (shelfIdx !== -1) {
                                response.ShelfDTO.subShelves[shelfIdx] = wrapper;
                            }
                        } else {
                            response.ShelfDTO.subShelves.push(wrapper);
                        }
                    } else {
                        const shelfIdx = response.ShelfDTO.subShelves.findIndex(
                            element => element.ShelfDTO.id === shelfId
                        );
                        response.ShelfDTO.subShelves[shelfIdx] = wrapper;
                    }
                    this.setState(() => updateShelf(response));
                })
                .catch(error => this.setState({loading: false, errorMessage: error}));
        }
    };

    handleUpdateExtAttributes = (tagArray, criteriaId) => {
        this.setState(prevState => {
            const criteriaArr = cloneDeep(prevState.criteria);
            const res = criteriaId.substring(18);
            const idx = Number(res);
            criteriaArr[idx].attributes = tagArray;
            return {criteria: criteriaArr};
        });
    };

    convertResolutionArrayToLogicalOrValue = resolutionArray => {
        let resolutionValue = 0;

        if (resolutionArray.length) {
            for (const currentResolution of resolutionArray) {
                if (currentResolution.selected) {
                    resolutionValue |= currentResolution.resId;
                }
            }
        }

        return resolutionValue;
    };

    convertGenresArrayToCatalogObj = tagArray => {
        const movieGenres = new Set();
        const tvGenres = new Set();
        const adultGenres = new Set();
        const genres = new Set();

        for (const genre of tagArray) {
            if (genre.category === 'MOVIE') {
                const movieGenre = {
                    category: 'MOVIE',
                    genreValue: genre.genreValue,
                };
                movieGenres.add(movieGenre);
            } else if (genre.category === 'TVENT') {
                const tvGenre = {
                    category: 'TVENT',
                    genreValue: genre.genreValue,
                };
                tvGenres.add(tvGenre);
            } else if (genre.category === 'ADULT') {
                const adultGenre = {
                    category: 'ADULT',
                    genreValue: genre.genreValue,
                };
                adultGenres.add(adultGenre);
            }
        }

        if (movieGenres.size) {
            let genreValue = 0;

            for (const genre of movieGenres) {
                genreValue |= genre.genreValue;
            }

            const movieGenre = {
                category: 'MOVIE',
                genreValue,
            };

            genres.add(movieGenre);
        }

        if (tvGenres.size) {
            let genreValue = 0;

            for (const genre of tvGenres) {
                genreValue |= genre.genreValue;
            }

            const tvGenre = {
                category: 'TVENT',
                genreValue,
            };
            genres.add(tvGenre);
        }

        if (adultGenres.size) {
            let genreValue = 0;

            for (const genre of adultGenres) {
                genreValue |= genre.genreValue;
            }

            const adultGenre = {
                category: 'ADULT',
                genreValue,
            };
            genres.add(adultGenre);
        }

        return Array.from(genres);
    };

    prepareCriteriaForSubmit = () => {
        const {criteria} = this.state;
        const criteriaArr = cloneDeep(criteria);

        for (let i = 0; i < criteriaArr.length; i++) {
            if (criteriaArr[i].class === 'Actor') {
                // Actor and criterion is stored as a Keyword criterion, with fields set to 2.
                criteriaArr[i].class = 'Keyword';
            } else if (criteria[i].class === 'SubTheme') {
                criteriaArr[i].genres = this.convertGenresArrayToCatalogObj(criteria[i].genres);
            } else if (criteria[i].class === 'Resolution') {
                criteriaArr[i].resolution = this.convertResolutionArrayToLogicalOrValue(criteria[i].resolution);
            } else if (criteriaArr[i].class === 'EchostarId') {
                criteriaArr[i].echostarIds = criteriaArr[i].echostarIds.split(',');
            } else if (criteriaArr[i].class === 'Title') {
                // Title and criterion is stored as a Keyword criterion, with fields set to 3.
                criteriaArr[i].class = 'Keyword';
            }
        }

        this.setState({criteria: criteriaArr});

        return criteriaArr;
    };

    addCriteria = () => {
        const {criteria, criteriaSelection} = this.state;

        let newCriteria = null;
        const criteriaArr = [...criteria];

        if (criteriaSelection === catalogConstants.CriterionList.Actor.criterionName) {
            newCriteria = {
                class: 'Actor' /* Change class to Keyword before submission */,
                keyword: '',
                matchType: 'DEFAULT',
                fields: 2,
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Directors.criterionName) {
            newCriteria = {
                class: 'Directors',
                directors: [],
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Keyword.criterionName) {
            newCriteria = {
                class: 'Keyword',
                keyword: '',
                matchType: 'DEFAULT',
                fields: 0,
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Aliases.criterionName) {
            newCriteria = {
                class: 'Aliases',
                aliases: [],
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.ReleaseYear.criterionName) {
            newCriteria = {
                class: 'ReleaseYear',
                releaseYear: new Date().getFullYear(),
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.CharacterPage.criterionName) {
            newCriteria = {
                class: 'CharacterPage',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.TVRating.criterionName) {
            newCriteria = {
                class: 'TVRating',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.CriticsRating.criterionName) {
            newCriteria = {
                class: 'CriticsRating',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Folder.criterionName) {
            newCriteria = {
                class: 'Folder',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Network.criterionName) {
            newCriteria = {
                class: 'Network',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.LateNight.criterionName) {
            newCriteria = {
                class: 'LateNight',
                includeLateNight: false,
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.SeriesID.criterionName) {
            newCriteria = {
                class: 'SeriesID',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.EchostarId.criterionName) {
            newCriteria = {
                class: 'EchostarId',
                echostarIDs: '',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.ProductType.criterionName) {
            newCriteria = {
                class: 'ProductType',
                productType: 0,
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Theme.criterionName) {
            newCriteria = {
                class: 'Theme',
                themeId: 1,
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.AirDayOfWeek.criterionName) {
            newCriteria = {
                class: 'AirDayOfWeek',
                airDayOfWeek: 'SUNDAY',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Amount.criterionName) {
            newCriteria = {
                class: 'Amount',
                amountFrom: undefined,
                amountTo: undefined,
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.NetworkTags.criterionName) {
            newCriteria = {
                class: 'NetworkTags',
                tags: [],
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.SubTheme.criterionName) {
            newCriteria = {
                class: 'SubTheme',
                genres: [],
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Resolution.criterionName) {
            newCriteria = {
                class: 'Resolution',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.RecommendationType.criterionName) {
            newCriteria = {
                class: 'RecommendationType',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.ReleaseDate.criterionName) {
            newCriteria = {
                class: 'ReleaseDate',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.MPAA.criterionName) {
            newCriteria = {
                class: 'MPAA',
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.ExtendedAttribute.criterionName) {
            newCriteria = {
                class: 'ExtendedAttribute',
                attributes: [],
            };
        } else if (criteriaSelection === catalogConstants.CriterionList.Title.criterionName) {
            newCriteria = {
                class: 'Title' /* Change class to Keyword before submission */,
                keyword: '',
                matchType: 'DEFAULT',
                fields: 3,
            };
        }
        if (Array.isArray(criteriaArr)) {
            criteriaArr.push(newCriteria);
        }

        this.setState({criteria: criteriaArr});
    };

    changeCriteria = e => {
        this.setState({criteriaSelection: e.target.value});
    };

    changeShelfType = e => {
        this.setState({shelfType: e.target.value, sortOptions: [], boosts: [], criteria: []});
    };

    handleUpdateAlias = (tagArray, criteriaId) => {
        this.setState(prevState => {
            const criteriaArr = cloneDeep(prevState.criteria);
            const res = criteriaId.substring(7);
            const idx = Number(res);
            criteriaArr[idx].aliases = tagArray;
            return {criteria: criteriaArr};
        });
    };

    handleUpdateSubTheme = (tagArray, criteriaId) => {
        this.setState(prevState => {
            const criteriaArr = cloneDeep(prevState.criteria);
            const res = criteriaId.substring(8);
            const idx = Number(res);
            criteriaArr[idx].genres = tagArray;
            return {criteria: criteriaArr};
        });
    };

    handleChange = ({target}) => {
        const {criteria} = this.state;
        const criteriaArr = cloneDeep(criteria);
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if (target.id.includes('actorName')) {
            const res = target.id.substring(9);
            const idx = Number(res);

            criteriaArr[idx].keyword = value;
        } else if (target.id.includes('directorName')) {
            const res = target.id.substring(12);
            const idx = Number(res);

            criteriaArr[idx].directors = value;
        } else if (target.id.includes('matchType')) {
            const res = target.id.substring(9);
            const idx = Number(res);

            criteriaArr[idx].matchType = value;
        } else if (target.id.includes('charPageStart')) {
            const res = target.id.substring(13);
            const idx = Number(res);

            criteriaArr[idx].startCharacter = value;
        } else if (target.id.includes('charPageEnd')) {
            const res = target.id.substring(11);
            const idx = Number(res);

            criteriaArr[idx].endCharacter = value;
        } else if (target.id.includes('keyword')) {
            const res = target.id.substring(7);
            const idx = Number(res);

            criteriaArr[idx].keyword = value;
        } else if (target.id.includes('fields')) {
            const res = target.id.substring(6);
            const idx = Number(res);

            criteriaArr[idx].fields = value;
        } else if (target.id.includes('tvRating')) {
            const res = target.id.substring(8);
            const idx = Number(res);

            criteriaArr[idx].rating = value;
        } else if (target.id.includes('mpaaRatingEntry')) {
            const endResIdx = target.id.indexOf('_');
            const criteriaId = target.id.substring(15, endResIdx);

            const idx = Number(criteriaId);

            const mpaaValueStr = target.id.substring(endResIdx + 1);
            const mpaaValue = Number(mpaaValueStr);

            let ratingsSet;
            if (criteriaArr[idx].ratings) {
                ratingsSet = new Set(criteriaArr[idx].ratings);
            } else {
                ratingsSet = new Set();
            }

            const mpaaRating = catalogConstants.MpaaRatingList[mpaaValue].value;

            if (ratingsSet.has(mpaaRating)) {
                ratingsSet.delete(mpaaRating);
            } else {
                ratingsSet.add(mpaaRating);
            }
            criteriaArr[idx].ratings = Array.from(ratingsSet);
        } else if (target.id.includes('releaseDecade')) {
            const endResIdx = target.id.indexOf('_');
            const criteriaId = target.id.substring(13, endResIdx);

            const idx = Number(criteriaId);

            const decadeIdStr = target.id.substring(endResIdx + 1);
            const decadeId = Number(decadeIdStr);

            let decadeSet;
            if (criteriaArr[idx].decades) {
                decadeSet = new Set(criteriaArr[idx].decades);
            } else {
                decadeSet = new Set();
            }

            const decadeSelection = catalogConstants.ReleaseDecadeList[decadeId].decadeName;

            if (decadeSet.has(decadeSelection)) {
                decadeSet.delete(decadeSelection);
            } else {
                decadeSet.add(decadeSelection);
            }
            criteriaArr[idx].decades = Array.from(decadeSet);
        } else if (target.id.includes('releaseYear')) {
            const res = target.id.substring(11);
            const idx = Number(res);

            criteriaArr[idx].releaseYear = value;
        } else if (target.id.includes('criticsRating')) {
            const res = target.id.substring(13);
            const idx = Number(res);

            criteriaArr[idx].lowCriticsRating = value;
        } else if (target.id.includes('featuredFolder')) {
            const res = target.id.substring(14);
            const idx = Number(res);

            criteriaArr[idx].featuredFolderID = value;
        } else if (target.id.includes('network')) {
            const res = target.id.substring(7);
            const idx = Number(res);

            criteriaArr[idx].name = value;
            criteriaArr[idx].networkSearchValue = value;
        } else if (target.id.includes('product')) {
            const res = target.id.substring(7);
            const idx = Number(res);

            criteriaArr[idx].type = value;
        } else if (target.id.includes('theme')) {
            const res = target.id.substring(5);
            const idx = Number(res);

            criteriaArr[idx].category = value;
        } else if (target.id.includes('lateNight')) {
            const res = target.id.substring(9);
            const idx = Number(res);

            criteriaArr[idx].includeLateNight = value;
        } else if (target.id.includes('seriesID')) {
            const res = target.id.substring(8);
            const idx = Number(res);

            criteriaArr[idx].seriesID = value;
        } else if (target.id.includes('echostarIDs')) {
            const res = target.id.substring(11);
            const idx = Number(res);

            criteriaArr[idx].echostarIds = value;
        } else if (target.id.includes('shelfName')) {
            this.setState({shelfName: value});
        } else if (target.id.includes('shelfDescription')) {
            this.setState({shelfDescription: value});
        } else if (target.id.includes('shelfReturnLimit')) {
            this.setState({shelfReturnLimit: value});
        } else if (target.id.includes('shelfType')) {
            this.setState({shelfType: value});
        } else if (target.id.includes('res')) {
            const endResIdx = target.id.indexOf('_');
            const res = target.id.substring(3, endResIdx);
            const idx = Number(res);
            const resType = target.id.substring(endResIdx + 1);
            const data = criteriaArr[idx].resolution;

            for (let i = 0; i < data.length; i++) {
                const res = data[i];
                if (res.resId == resType) {
                    res.selected = value;
                }
            }

            criteriaArr[idx].resolution = data;
        } else if (target.id.includes('airDayOfWeek')) {
            const res = target.id.substring(12);
            const idx = Number(res);

            criteriaArr[idx].dayOfWeek = value;
        } else if (target.id.includes('amountFrom') && !isNaN(value)) {
            const res = target.id.substring(10);
            const idx = Number(res);

            criteriaArr[idx].amountFrom = value;
        } else if (target.id.includes('amountTo') && !isNaN(value)) {
            const res = target.id.substring(8);
            const idx = Number(res);

            criteriaArr[idx].amountTo = value;
        } else if (target.id.includes('additionalData')) {
            const res = target.id.substring(14);
            const idx = Number(res);

            criteriaArr[idx].additionalData = value;
        } else if (target.id.includes('recommendationsEngine')) {
            const res = target.id.substring(21);
            const idx = Number(res);

            criteriaArr[idx].type = value;
        } else if (target.id.includes('titleName')) {
            const res = target.id.substring(9);
            const idx = Number(res);

            criteriaArr[idx].keyword = value;
        }

        this.setState({criteria: criteriaArr});
    };

    reorderSortOptionList = updatedSortOptions => {
        const sortOptions = [];

        for (let i = 0; i < updatedSortOptions.length; i++) {
            sortOptions.push(updatedSortOptions[i]);
        }

        this.setState({sortOptions});
    };

    updateSortOptionList = modifiedSortOptions => {
        let {sortOptions} = this.state;
        if (sortOptions) {
            sortOptions.push(modifiedSortOptions);
        } else {
            sortOptions = [modifiedSortOptions];
        }

        this.setState({sortOptions});
    };

    updateSortOrder = selectedItems => {
        const {sortOptions} = this.state;

        for (let s = 0; s < sortOptions.length; s++) {
            for (let i = 0; i < selectedItems.length; i++) {
                if (selectedItems[i].method === sortOptions[s].method) {
                    sortOptions[s].order =
                        sortOptions[s].order === 'ASCENDING'
                            ? (sortOptions[s].order = 'DESCENDING')
                            : (sortOptions[s].order = 'ASCENDING');
                }
            }
        }

        this.setState({sortOptions});
    };

    reorderBoostList = boostList => {
        const boost = [];

        for (let i = 0; i < boostList.length; i++) {
            boost.push(boostList[i]);
        }

        this.setState({boosts: boost});
    };

    updateBoostList = (boostObj, insertOperation) => {
        const {boosts, shelfType} = this.state;
        let boostArray = cloneDeep(boosts);

        if (!insertOperation) {
            if (shelfType === 'ASSET') {
                const assetPromotionBoostIdx = boostArray.findIndex(
                    currentBoost => currentBoost.class === 'AssetPromotionList'
                );
                boostArray[assetPromotionBoostIdx].featuredFolderID = boostObj.featuredFolderID;
            } else if (shelfType === 'NETWORK') {
                const networkPromotionBoostIdx = boostArray.findIndex(
                    currentBoost => currentBoost.class === 'NetworkPromotionList'
                );

                boostArray[networkPromotionBoostIdx] = boostObj;
            }
        } else if (boosts) {
            boostArray.push(boostObj);
        } else {
            boostArray = [boostObj];
        }
        this.setState({boosts: boostArray});
    };

    updateResolutionList = criteriaId => {
        const {criteria} = this.state;

        const criteriaArray = cloneDeep(criteria);

        if (criteriaArray) {
            if (!criteriaArray[criteriaId].resolution) {
                criteriaArray[criteriaId].resolution = [];

                criteriaArray[criteriaId].resolution = catalogConstants.ResolutionList.map(resolution => ({
                    resId: resolution.searchValue,
                    state: false,
                }));
            }
        }

        this.setState({criteria: criteriaArray});
    };

    handleCancelClick = event => {
        const {historyProps} = this.props;

        event.preventDefault();
        historyProps.goBack();
    };

    alreadyQuoted = value => {
        let endVal = 0;
        const startVal = value.indexOf('\'');
        if (startVal >= 0) {
            endVal = value.substring(startVal + 1).indexOf('\'');
            if (endVal > 0) {
                return true;
            }
        }

        return false;
    };

    deleteCriteria = criteriaClassToDelete => {
        const {criteria} = this.state;
        const criteriaArr = criteria.filter(tag => tag.class !== criteriaClassToDelete);

        this.setState({criteria: criteriaArr});
    };

    deleteSelectedSortOptions = sortOptionsToDelete => {
        const {sortOptions} = this.state;
        let currentSortOptions = cloneDeep(sortOptions);
        sortOptionsToDelete.forEach(element => {
            currentSortOptions = currentSortOptions.filter(tag => tag.method !== element.method);
        });
        this.setState({sortOptions: currentSortOptions});
    };

    deleteSelectedBoosts = boostsToDelete => {
        const {boosts, shelfType} = this.state;
        let currentBoosts = cloneDeep(boosts);

        if (shelfType === 'ASSET') {
            boostsToDelete.forEach(element => {
                currentBoosts = currentBoosts.filter(tag => tag.class !== element.class);
            });
        } else if (shelfType === 'NETWORK') {
            boostsToDelete.forEach(element => {
                currentBoosts = currentBoosts.filter(tag => tag.name !== element.name);
            });
        }

        this.setState({boosts: currentBoosts});
    };

    launchIdCheckersBehavior = parentStatus => {
        this.setState(
            !parentStatus
                ? {
                      generateLaunchId: parentStatus,
                      generateLaunchIdMethod: '',
                      launchIdFromListGenerated: null,
                      showLaunchIdList: false,
                      showCustomLaunchId: false,
                      customLaunchId: '',
                      customLaunchIdValueIsVerified: true,
                      launchIdErrorMessage: null,
                  }
                : {
                      generateLaunchId: parentStatus,
                  }
        );
    };

    generateLaunchIdCheckBox() {
        const {generateLaunchId} = this.state;

        return (
            <div className="p-d-flex p-flex-row" style={styles.generateLaunchId}>
                <Checkbox
                    checked={generateLaunchId}
                    id="isLaunchId"
                    style={styles.checkbox}
                    onChange={e => this.launchIdCheckersBehavior(e.checked)}
                />
                <label htmlFor="isLaunchId" style={styles.label}>
                    Generate or Modify Launch ID
                </label>
            </div>
        );
    }

    setSelectedLaunchId = launchIdSelected => {
        const {launchId} = this.state;
        this.setState({launchIdFromListGenerated: launchId !== launchIdSelected ? launchIdSelected : null});
    };

    generateLaunchIdMethod() {
        const {generateLaunchIdMethod, showLaunchIdList, launchIdFromListGenerated} = this.state;
        const {searchValues} = this.props;

        return (
            <div>
                <div className="p-d-flex p-flex-row p-jc-center" style={styles.generateLaunchIdMethod}>
                    <div className="p-field-radiobutton">
                        <RadioButton
                            checked={generateLaunchIdMethod === 'auto'}
                            inputId="isLaunchIdA"
                            name="isLaunchIdA"
                            style={styles.generateLaunchIdA}
                            value="auto"
                            onChange={e =>
                                this.setState({
                                    generateLaunchIdMethod: e.value,
                                    showLaunchIdList: false,
                                    launchIdFromListGenerated: null,
                                    showCustomLaunchId: false,
                                    customLaunchId: '',
                                    customLaunchIdValueIsVerified: true,
                                    launchIdErrorMessage: null,
                                })
                            }
                        />
                        <label htmlFor="isLaunchIdA">Generate Launch ID on Shelf Submit</label>
                    </div>
                    <div className="p-field-radiobutton">
                        <RadioButton
                            checked={generateLaunchIdMethod === 'list'}
                            inputId="isLaunchIdL"
                            name="isLaunchIdL"
                            style={styles.generateLaunchIdL}
                            value="list"
                            onChange={e =>
                                this.setState({
                                    generateLaunchIdMethod: e.value,
                                    showLaunchIdList: true,
                                    showCustomLaunchId: false,
                                    customLaunchId: '',
                                    customLaunchIdValueIsVerified: true,
                                    launchIdErrorMessage: null,
                                })
                            }
                        />
                        <label htmlFor="isLaunchIdL">Select an existing Launch ID</label>
                    </div>
                    <div className="p-field-radiobutton">
                        <RadioButton
                            checked={generateLaunchIdMethod === 'custom'}
                            inputId="isLaunchIdC"
                            name="isLaunchIdC"
                            style={styles.generateLaunchIdC}
                            value="custom"
                            onChange={e =>
                                this.setState({
                                    generateLaunchIdMethod: e.value,
                                    showCustomLaunchId: true,
                                    showLaunchIdList: false,
                                    launchIdFromListGenerated: null,
                                })
                            }
                        />
                        <label htmlFor="isLaunchIdC">Set/Remove Launch ID</label>
                    </div>
                </div>
                <div>
                    {showLaunchIdList &&
                        searchValues &&
                        searchValues.ShelfDTO &&
                        launchIdFromListGenerated != null &&
                        generateLaunchIdMethod === 'list' &&
                        this.showGeneratedLaunchId()}
                </div>
            </div>
        );
    }

    loadingShelves = () => (
        <div className="p-d-flex p-jc-center" style={styles.loadingBlock}>
            <span>Loading Shelves...</span>
            <Icon className="loading--icon" fontAwesomeType="spinner" spin={true} style={styles.loaderSpinner} />
        </div>
    );

    showLaunchIdSelector = () => {
        const {shelvesTreeData} = this.props;
        if (shelvesTreeData && shelvesTreeData.ShelfDTO) {
            return (
                <div>
                    <LaunchIdTreeTable data={shelvesTreeData} setSelectedLaunchId={this.setSelectedLaunchId} />
                </div>
            );
        }
        return <div>{this.loadingShelves()}</div>;
    };

    showCustomLaunchIdControls = () => {
        const {customLaunchId, launchId, customLaunchIdValueIsVerified, launchIdErrorMessage} = this.state;
        const {shelvesTreeData} = this.props;
        const warningText = 'If the value of the new Launch ID is empty, Launch ID for this record will be removed';
        const duplicateText = 'Please specify another Launch ID, different from the existing one for the current shelf';
        if (shelvesTreeData && shelvesTreeData.ShelfDTO) {
            return (
                <div className="p-d-flex p-flex-column" style={styles.lid}>
                    <label htmlFor="li">Type the value of the new Launch ID</label>

                    <InputText
                        id="lid"
                        value={customLaunchId}
                        onChange={e =>
                            this.setState({
                                customLaunchId: e.target.value,
                                customLaunchIdValueIsVerified: !e.target.value.toString().length,
                                launchIdErrorMessage: null,
                            })
                        }
                    />
                    {!customLaunchId.toString().length ? (
                        <div style={styles.lid_warning}>
                            <i className="pi pi-info-circle" style={styles.infoIcon} />
                            <span style={styles.infoText}>{warningText}</span>
                        </div>
                    ) : null}

                    {(launchIdErrorMessage && launchIdErrorMessage.length) ||
                    (launchId &&
                        customLaunchId.toString().length &&
                        customLaunchId.toString() === launchId.toString()) ? (
                        <small className="p-invalid p-d-block" id="lid-help" style={styles.lid_error}>
                            {launchIdErrorMessage && launchIdErrorMessage.length ? launchIdErrorMessage : duplicateText}
                        </small>
                    ) : null}

                    {launchIdErrorMessage == null && customLaunchId.toString().length ? (
                        <PrimeButton
                            className={customLaunchIdValueIsVerified ? 'p-button-success' : 'p-button-danger'}
                            icon={customLaunchIdValueIsVerified ? 'pi pi-check' : 'pi pi-question'}
                            label={
                                customLaunchIdValueIsVerified
                                    ? `The Launch ID value ${customLaunchId} is OK!`
                                    : 'Click to check the Launch ID'
                            }
                            style={styles.lid_button}
                            onClick={() => {
                                this.checkLaunchId();
                            }}
                        />
                    ) : null}
                </div>
            );
        }
        return <div>{this.loadingShelves()}</div>;
    };

    checkLaunchId = () => {
        const {shelvesTreeData} = this.props;
        if (shelvesTreeData.ShelfDTO) {
            const {customLaunchId} = this.state;
            const {subShelves} = shelvesTreeData.ShelfDTO;
            const foundShelves = subShelves.find(s => {
                const {launchId} = s.ShelfDTO;
                if (launchId && launchId === parseInt(customLaunchId)) {
                    return s;
                }
            });
            if (!foundShelves || !foundShelves.ShelfDTO) {
                this.setState({
                    customLaunchIdValueIsVerified: false,
                    launchIdErrorMessage:
                        'This Launch ID does not exist. To generate the new Launch ID, select the `Generate Launch ID on Shelf Submit` radio button.',
                });
            } else {
                const obj = foundShelves.ShelfDTO;
                this.setState({
                    launchIdObject: {name: obj.name, description: obj.description, id: obj.id},
                    showLaunchIdConfirmation: true,
                    launchIdErrorMessage: null,
                });
            }
        } else {
            this.setState({customLaunchIdValueIsVerified: false});
        }
    };

    showGeneratedLaunchId = () => {
        const {launchIdFromListGenerated, launchId} = this.state;
        const {formName} = this.props;
        return (
            <div style={styles.generatedLaunchIdDiv}>
                <span style={styles.generatedLaunchIdField}>{`Selected: ${launchIdFromListGenerated}`}</span>
                {formName !== 'addShelf' && launchId != null && (
                    <span style={styles.generatedLaunchIdField2}>{`Previous: ${launchId}`}</span>
                )}
            </div>
        );
    };

    renderShelfIsAlpha() {
        const {shelfIsAlpha} = this.state;

        return (
            <div className="p-d-flex p-flex-row" style={styles.renderShelfDiv}>
                <Checkbox
                    checked={shelfIsAlpha}
                    id="inShelfAlpha"
                    style={styles.checkbox}
                    onChange={e => this.setState({shelfIsAlpha: e.checked})}
                />
                <label htmlFor="inShelfAlpha" style={styles.renderShelfLabel}>
                    is Alpha?
                </label>
            </div>
        );
    }

    renderShelfReturnLimit() {
        const {shelfReturnLimit} = this.state;

        return (
            <div>
                <label htmlFor="in">Shelf ReturnLimit</label>

                <InputText
                    id="in"
                    keyfilter="pint"
                    style={styles.limit}
                    value={shelfReturnLimit}
                    onChange={e => this.setState({shelfReturnLimit: e.target.value})}
                />
            </div>
        );
    }

    renderShelfDescription() {
        const {shelfDescription} = this.state;

        return (
            <div>
                <label htmlFor="in">Shelf Description</label>
                <InputTextarea
                    cols={30}
                    rows={3}
                    style={styles.description}
                    value={shelfDescription}
                    onChange={e => this.setState({shelfDescription: e.target.value})}
                />
            </div>
        );
    }

    renderShelfAreSeriesFoldersGrouped() {
        const {shelfAreSeriesFoldersGrouped, shelfType} = this.state;

        return (
            <div className="p-d-flex p-flex-row" style={styles.groupedDiv}>
                <Checkbox
                    checked={shelfAreSeriesFoldersGrouped}
                    disabled={shelfType !== 'ASSET' && shelfType !== 'RECOMMENDATION'}
                    id="inShelfAreSeriesFoldersGrouped"
                    style={styles.checkbox}
                    onChange={e => this.setState({shelfAreSeriesFoldersGrouped: e.checked})}
                />
                <label htmlFor="inShelfAreSeriesFoldersGrouped" style={styles.groupedLabel}>
                    Are Series Folders Grouped?
                </label>
            </div>
        );
    }

    renderCancelButton() {
        const {editing} = this.props;

        return !editing ? <Button {...this.getCancelButtonProps()}>Cancel</Button> : null;
    }

    renderShelfName() {
        const {shelfName, errorMessage} = this.state;
        return (
            <div>
                <label htmlFor="inshelfName">Shelf Name</label>
                <InputText
                    id="inshelfName"
                    style={styles.shelfName}
                    value={shelfName}
                    onChange={e =>
                        this.setState({
                            shelfName: e.target.value,
                            errorMessage: e.target.value && e.target.value.length ? null : 'Shelf Name is required',
                        })
                    }
                />
                <small className="p-invalid p-d-block" id="linshelfName" style={styles.lid_error}>
                    {errorMessage}
                </small>
            </div>
        );
    }

    renderFooter = () => (
        <div>
            <PrimeButton
                className="p-button-danger"
                icon="pi pi-times"
                label="No"
                onClick={() => this.setState({customLaunchIdValueIsVerified: false, showLaunchIdConfirmation: false})}
            />
            <PrimeButton
                autoFocus={true}
                className="p-button-success"
                icon="pi pi-check"
                label="Yes"
                onClick={() => this.setState({customLaunchIdValueIsVerified: true, showLaunchIdConfirmation: false})}
            />
        </div>
    );

    renderShelf() {
        const {formName, searchValues} = this.props;
        const {
            criteria,
            criteriaSelection,
            generateLaunchId,
            generateLaunchIdMethod,
            shelfType,
            showLaunchIdList,
            showCustomLaunchId,
            showLaunchIdConfirmation,
            launchIdObject,
            customLaunchId,
            launchId,
        } = this.state;

        const formProps = {
            className: 'shelf-form',
            fixedPositionedResponse: true,
            name: formName,
            resetOnSubmit: formName === 'updateShelf',
            submitData: true,
        };

        const firstTabHeader = formName === 'addShelf' ? 'Add Shelf' : 'Edit Shelf';

        const shelfOptions = Object.keys(catalogConstants.ShelfTypes).map(shelfType => ({
            label: catalogConstants.ShelfTypes[shelfType].label,
            value: shelfType,
        }));

        // Filter available criteria based on selected ShelfType
        const allCriteriaOptions = Object.keys(catalogConstants.CriterionList).map(criterion => ({
            label: catalogConstants.CriterionList[criterion].criterionName,
            value: catalogConstants.CriterionList[criterion].criterionName,
            shelfTypes: catalogConstants.CriterionList[criterion].shelfTypes,
        }));

        const currentShelfTypeObj = catalogConstants.ShelfTypes[shelfType];

        let criteriaOptions = allCriteriaOptions
            .filter(criterion =>
                criterion.shelfTypes.includes(
                    criterion.shelfTypes.find(currentShelfType => currentShelfType.label === currentShelfTypeObj.label)
                )
            )
            .map(criterion => ({
                label: criterion.label,
                value: criterion.label,
            }));

        // Filter out criteria the user has already added to the Shelf.
        criteriaOptions = criteriaOptions.filter(
            item =>
                !criteria.includes(
                    criteria.find(el => catalogConstants.CriterionList[el.class].criterionName === item.value)
                )
        );

        return (
            <Form {...formProps}>
                <TabView renderActiveOnly={true} style={styles.tabs}>
                    <TabPanel header={firstTabHeader}>
                        <div className="p-d-flex p-flex-row">
                            <div className="p-d-flex p-flex-column" style={styles.shelfType}>
                                <label htmlFor="cboShelfType">Shelf Type</label>
                                <Dropdown
                                    disabled={formName === 'editShelf'}
                                    filterPlaceholder="Select Shelf Type"
                                    id="cboShelfType"
                                    options={shelfOptions}
                                    showClear={false}
                                    style={styles.typeDropdown}
                                    value={shelfType}
                                    onChange={this.changeShelfType}
                                />
                            </div>
                            {this.renderShelfName()}
                        </div>
                        <div className="p-d-flex p-flex-column" style={styles.divBlock}>
                            {this.renderShelfDescription()}
                        </div>
                        <div className="p-d-flex p-flex-row" style={styles.divBlock}>
                            {this.renderShelfReturnLimit()}
                            {this.renderShelfIsAlpha()}
                            {this.renderShelfAreSeriesFoldersGrouped()}
                            {this.generateLaunchIdCheckBox()}
                        </div>
                        {generateLaunchId && (
                            <div className="p-d-flex p-flex-row p-jc-center" style={styles.launchIdInfo}>
                                {`Current Launch ID ${launchId && launchId.toString().length ? launchId : ' is empty'}`}
                            </div>
                        )}

                        <div className="p-d-flex p-flex-row" style={styles.divBlock}>
                            {generateLaunchId && this.generateLaunchIdMethod()}
                        </div>

                        <div className="p-d-flex p-flex-row p-jc-center">
                            {showLaunchIdList && generateLaunchIdMethod === 'list' && this.showLaunchIdSelector()}
                        </div>

                        <div className="p-d-flex p-flex-row p-jc-center">
                            {showCustomLaunchId &&
                                generateLaunchIdMethod === 'custom' &&
                                this.showCustomLaunchIdControls()}
                        </div>

                        <div className="p-d-flex p-flex-row">
                            <div className="p-d-flex p-flex-column">
                                <label>Criteria List</label>
                                <Dropdown
                                    disabled={!criteriaOptions.length}
                                    filter={true}
                                    filterBy="label,value"
                                    filterPlaceholder="Select Criterion"
                                    options={criteriaOptions}
                                    showClear={false}
                                    value={criteriaSelection}
                                    onChange={this.changeCriteria}
                                />
                            </div>
                            <Button
                                disabled={!criteriaOptions.length}
                                {...this.getFieldProps('btnAddCriteria')}
                                style={styles.criteriaButton}
                                onClick={this.addCriteria}
                            >
                                Add Criteria
                            </Button>
                        </div>
                        <div className="p-d-flex p-flex-column">
                            <CriteriaForm
                                deleteCriteria={this.deleteCriteria}
                                handleChange={this.handleChange}
                                handleUpdateAlias={this.handleUpdateAlias}
                                handleUpdateExtAttributes={this.handleUpdateExtAttributes}
                                handleUpdateNetworkTags={this.handleUpdateNetworkTags}
                                handleUpdateSubTheme={this.handleUpdateSubTheme}
                                shelfObj={this.state}
                                tyle={true}
                                updateResolutionList={this.updateResolutionList}
                            />
                        </div>
                    </TabPanel>
                    <TabPanel disabled={shelfType !== 'ASSET' && shelfType !== 'NETWORK'} header="Sort Options">
                        <SortOptionList
                            deleteSelectedSortOptions={this.deleteSelectedSortOptions}
                            id="sortoption"
                            name="sortoption"
                            reorderSortOptionList={this.reorderSortOptionList}
                            shelfType={shelfType}
                            updateSortOptionList={this.updateSortOptionList}
                            updateSortOrder={this.updateSortOrder}
                            {...this.getSortOptionProps()}
                            onChange={this.handleChange}
                        />
                    </TabPanel>
                    <TabPanel disabled={shelfType !== 'ASSET' && shelfType !== 'NETWORK'} header="Boosts">
                        <BoostListTable
                            deleteSelectedBoosts={this.deleteSelectedBoosts}
                            id="boost"
                            name="boost"
                            reorderBoostList={this.reorderBoostList}
                            shelfType={shelfType}
                            updateBoostList={this.updateBoostList}
                            {...this.getBoostProps()}
                            onChange={this.handleChange}
                        />
                    </TabPanel>
                </TabView>

                <div className="p-d-flex p-flex-row" style={styles.buttonBlock}>
                    <Button {...this.getSubmitProps()}>Submit</Button>
                    {this.renderCancelButton()}
                </div>

                <Dialog
                    className="launchIdDialog"
                    footer={this.renderFooter()}
                    header="Warning! Found shelf with the same Launch ID."
                    maximizable={false}
                    modal={true}
                    style={{width: '50vw'}}
                    visible={showLaunchIdConfirmation}
                    onHide={() => this.setState({showLaunchIdConfirmation: false})}
                >
                    <div className="card">
                        <DataTable value={[launchIdObject]}>
                            <Column field="id" header="ID" />
                            <Column field="name" header="Name" />
                            <Column field="description" header="Description" />
                        </DataTable>
                        <div className="p-d-flex p-flex-row p-jc-center">{`Do you want to take the Launch ID ${customLaunchId} from "${launchIdObject.name}" and assign it to the current shelf?`}</div>
                    </div>
                </Dialog>
            </Form>
        );
    }

    render() {
        const {fetching, formName} = this.props;
        const {loading} = this.state;

        return (
            <div className="shelf-form-loading">
                <Dialog
                    className="progressShow"
                    closeOnEscape={false}
                    maximizable={false}
                    modal={true}
                    showHeader={false}
                    style={{width: 300}}
                    visible={fetching || loading}
                    onHide={e => e}
                >
                    <div className="p-d-flex p-flex-row p-jc-center" style={styles.loadingDiv}>
                        <Icon fontAwesomeType="spinner" spin={true} style={styles.loadingIcon} />
                        <span style={{marginLeft: 20}}>
                            {formName === 'addShelf' ? 'Adding shelf...' : 'Updating shelf...'}
                        </span>
                    </div>
                </Dialog>
                {this.renderShelf()}
            </div>
        );
    }
}

ShelfForm.propTypes = {
    cancelEditing: PropTypes.func,
    className: PropTypes.string,
    clientId: PropTypes.string,
    editing: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    formName: PropTypes.string.isRequired,
    getGlobalShelvesTree: PropTypes.func,
    historyProps: PropTypes.object.isRequired,
    parentShelfId: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
    redirectLocation: PropTypes.string.isRequired,
    resetForm: PropTypes.func,
    routerParams: PropTypes.object,
    searchValues: PropTypes.object,
    setFieldValue: PropTypes.func,
    shelvesTreeData: PropTypes.object,
    updateShelf: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({...state.updateShelf, ...state.servicesSearchData});
const mapDispatchToProps = dispatch => bindActionCreators({...shelfActions, getGlobalShelvesTree, push}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ShelfForm);
